<!-- ========== Wrapper ============= -->

<!-- sidebar menu area starts --><!--Loader-->

<div class="page-container" [ngClass]="{ sbar_collapsed: globals.sidebar_collapsed }">
  <div class="sidebar-menu">
    <app-left-navbar></app-left-navbar>
  </div>
  <!-- sidebar menu area ends -->

  <!--- Content Area Wrapper -->
  <div class="main-content">
    <!-- header area starts -->
    <div class="header-area">
      <app-header></app-header>
    </div>
    <!-- header area ends -->

    <div class="main-content-inner">
      <!--      Sample-->
      <div class="card main-area">
        <div class="card-body">
          <app-lobby-status-bar *ngIf="isLTLicenseEnabled$ | async" [locationId]="lobbyLocationId"
            [tenantId]="tenantId"></app-lobby-status-bar>
          <ng-template #templateapp let-anchor>
            <span>{{ anchor.nativeElement.innerText }}</span>
          </ng-template>
          <div showOn="none" kendoTooltip [tooltipTemplate]="templateapp" filter=".k-grid td"
            (mouseover)="showTooltip($event)">

            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--- Content Area Wrapper -->
</div>
<!-- ========== Wrapper ============= -->